import React from "react";
import { useIntl } from "react-intl";
import { PeekBox, PeekButton, PeekIconButton, PeekStack, PeekTypography, useTheme, } from "@piiqtechnologies/ui-components";
import { X } from "@piiqtechnologies/svg-icons";
import messages from "./messages.i18n";
export const TutorialTooltip = ({ index, size, isLastStep, step, backProps, primaryProps, closeProps, tooltipProps, config, }) => {
    var _a, _b;
    const theme = useTheme();
    const intl = useIntl();
    const primaryLabel = isLastStep && (config === null || config === void 0 ? void 0 : config.lastStepButtonLabel)
        ? config.lastStepButtonLabel
        : ((_a = config === null || config === void 0 ? void 0 : config.primaryButtonLabel) !== null && _a !== void 0 ? _a : intl.formatMessage(messages.next));
    const indicatorLabel = isLastStep && (config === null || config === void 0 ? void 0 : config.lastStepIndicatorLabel)
        ? config.lastStepIndicatorLabel
        : ((_b = config === null || config === void 0 ? void 0 : config.stepIndicatorLabel) !== null && _b !== void 0 ? _b : intl.formatMessage(messages.stepIndicator, { current: index + 1, total: size }));
    const showPrimaryButton = !isLastStep || !!(config === null || config === void 0 ? void 0 : config.lastStepButtonLabel);
    return (React.createElement(PeekBox, Object.assign({ sx: {
            backgroundColor: theme.palette.primary.main,
            p: 2.5,
            borderRadius: 2,
            width: 320,
            position: "relative",
        } }, tooltipProps),
        React.createElement(PeekBox, { sx: { position: "absolute", top: 12, right: 12 } },
            React.createElement(PeekIconButton, Object.assign({ size: "small", bordered: false, sx: { color: theme.palette.common.white } }, closeProps),
                React.createElement(X, { fontSize: 18 }))),
        React.createElement(PeekStack, { direction: "column", spacing: 2 },
            React.createElement(PeekStack, { direction: "column", spacing: 1, pr: 4 },
                React.createElement(PeekTypography, { variant: "h3", fontWeight: "fontWeightBold", color: theme.palette.common.white }, step.title),
                React.createElement(PeekTypography, { variant: "h4", color: theme.palette.common.white, sx: { opacity: 0.85 } }, step.content)),
            React.createElement(PeekStack, { direction: "row", justifyContent: "space-between", alignItems: "center" },
                React.createElement(PeekTypography, { variant: "h4", color: "secondary.main", fontWeight: "fontWeightMedium" }, indicatorLabel),
                React.createElement(PeekStack, { direction: "row", spacing: 1, alignItems: "center" },
                    index > 0 && (React.createElement(PeekButton, Object.assign({ size: "large", sx: { color: theme.palette.common.white } }, backProps), intl.formatMessage(messages.back))),
                    showPrimaryButton && (React.createElement(PeekButton, Object.assign({ size: "large", variant: "contained", color: "secondary" }, primaryProps), primaryLabel)))))));
};
export default TutorialTooltip;
